<template>
  <div class="login"></div>
</template>

<script>
import '@/assets/images/headway-5QgIuuBxKwM-unsplash.jpg';

export default {};
</script>

<style>
.login {
  /* background-image: url('https://images.pexels.com/photos/186077/pexels-photo-186077.jpeg'); */
  background-image: url('~@/assets/images/headway-5QgIuuBxKwM-unsplash.jpg');
  background-size: cover;
  height: 100%;
}
</style>
